import { PropsWithChildren} from "react";
import SignInPage from "../Auth/SignInPage";
import useAuthHook from "../../helpers/useAuthHook";

const AuthContainer = (props: PropsWithChildren<any>) => {
    const [currentUser, _, onSignIn] = useAuthHook();
    return (currentUser ? props.children : <SignInPage onSignIn={onSignIn}/>);
};

export default AuthContainer;